export const getWalletNameFilter = (
  queryFilterWallet:
    | FilterValueOption
    | FilterValueOption[]
    | string
    | null
    | undefined
): string | undefined => {
  if (typeof queryFilterWallet === 'string') {
    return queryFilterWallet
  }

  if (Array.isArray(queryFilterWallet)) {
    return queryFilterWallet[0]?.value
  }

  return queryFilterWallet?.value
}
